export const appStoreUrl =
  "https://apps.apple.com/us/app/granted-health/id6473135975";

export const companyName = "Granted Health";
